import {
  getAislesList,
  getChainsList,
  getCountriesList,
  getDetectionsList,
  getImagesList,
  getSessionsList,
  getShareState,
  getStoresList,
  isLoadingAisles,
  isLoadingChains,
  isLoadingCountries,
  isLoadingDetections,
  isLoadingImages,
  isLoadingLayoutIds,
  isLoadingSessions,
  isLoadingSources,
  isLoadingStores,
  layoutIds,
  sources,
} from 'core/selectors';
import { getAisles } from 'core/slices/aisles';
import { getChains } from 'core/slices/chains';
import { getCountries } from 'core/slices/countries';
import { clearDetections, getDetectionsByValue } from 'core/slices/detections';
import {
  cleanImage,
  cleanImages,
  getImages,
  signImage,
} from 'core/slices/images';
import { getLayoutIds } from 'core/slices/layoutIds';
import { cleanSessions, getSessions } from 'core/slices/sessions';
import { setSnackAlert } from 'core/slices/snackAlert';
import { getSources } from 'core/slices/sources';
import { cleanStores, getStores } from 'core/slices/stores';
import { connect } from 'react-redux';

import TopMenu from '../../../components/visualizer/TopMenu';

export default connect(
  state => ({
    countries: getCountriesList(state),
    chains: getChainsList(state),
    stores: getStoresList(state),
    sessions: getSessionsList(state),
    aisles: getAislesList(state),
    sources: sources(state),
    layoutIds: layoutIds(state),
    images: getImagesList(state),
    isLoadingCountries: isLoadingCountries(state),
    isLoadingChains: isLoadingChains(state),
    isLoadingStores: isLoadingStores(state),
    isLoadingSessions: isLoadingSessions(state),
    isLoadingAisles: isLoadingAisles(state),
    isLoadingSources: isLoadingSources(state),
    isLoadingLayoutIds: isLoadingLayoutIds(state),
    isLoadingImages: isLoadingImages(state),
    recievedState: getShareState(state),
    detections: getDetectionsList(state),
    isLoadingDetections: isLoadingDetections(state),
  }),
  {
    getCountries,
    getChains,
    getStores,
    getSessions,
    getAisles,
    getSources,
    getLayoutIds,
    getImages,
    signImage,
    cleanImage,
    cleanImages,
    cleanSessions,
    cleanStores,
    getDetectionsByValue,
    clearDetections,
    setSnackAlert,
  },
)(TopMenu);
